import React from 'react';
import { TrainingPlansSection } from '../components/TrainingPlansSection';
import { HeroSection } from '../components/HeroSection';
import { FAQSection } from '../components/FAQSection';
import { FreeTipsSection } from '../components/FreeTipsSection';
import { ContactSection } from '../components/ContactSection';
import { Footer } from '../components/Footer';
export const TrainingPlansLandingPage: React.FC = () => {
  return <div className="bg-black text-white min-h-screen" data-id="element-1897">
      {/* Hero section - same as main page */}
      <HeroSection data-id="element-1898" />

      {/* Training Plans Section - without progress section */}
      <TrainingPlansSection showProgressSection={false} data-id="element-1899" />

      {/* FAQ Section */}
      <FAQSection data-id="element-1900" />

      {/* Free Tips Section - moved above Contact */}
      <FreeTipsSection data-id="element-1901" />

      {/* Contact Section */}
      <ContactSection data-id="element-1902" />

      {/* Footer */}
      <Footer data-id="element-1903" />
    </div>;
};